export interface Account {
  ID: number;
  TARGET_DATE: Date;
  TYPE: number;
  CATEGORY: string;
  DETAIL: string;
  AMOUNT: number;
}

export const addAccount = async (list: Account[]) => {
  let result = null;
  await fetch("/account.php?cmd=insertBulk", {
    method: "post",
    body: JSON.stringify(list),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const updateAccount = async (item: Account) => {
  let result = null;
  await fetch("/account.php?cmd=updateBudget", {
    method: "post",
    body: JSON.stringify(item),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const removeAccount = async (item: Account) => {
  let result = null;
  await fetch("/account.php?cmd=delete", {
    method: "post",
    body: JSON.stringify(item),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const getAccount = async (year: number, month: number) => {
  let result: Account[] = [];
  const startDate = `${year}-${month.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}-17`;
  const endDate = `${year}-${(month + 1).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}-16`;

  await fetch("/account.php?cmd=get", {
    method: "post",
    body: JSON.stringify({ START_DATE: startDate, END_DATE: endDate }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    }) 
    .then((res) => {
      res.forEach((r: any) => {
        let rItem: Account = {
          ID: +r.ID,
          TARGET_DATE: r.TARGET_DATE,
          TYPE: +r.TYPE,
          CATEGORY: r.CATEGORY,
          DETAIL: r.DETAIL,
          AMOUNT: +r.AMOUNT,
        };
        result.push(rItem);
      });
    });
  localStorage.setItem("accounts", JSON.stringify(result));
  return result;
};
